import Http from '@/plugins/http.js';

export default {
    saveDataSource(datas) {
        var obj = { models: datas };
        return Http.POST(`api/DataSource/SaveDataSource`, obj);
    },
    getRecycleList(code, obj) {
        return Http.POST(`api/DataSource/GetRecycleList/${code}`, obj);
    },
    deleteField(code, obj) {
        return Http.POST(`api/DataSource/DeleteField/${code}`, obj);
    },
    resumeField(code, obj) {
        return Http.POST(`api/DataSource/ResumeField/${code}`, obj);
    },
    addFolder(folderInfo) {
        // { Code: '', Name: '' }
        return Http.POST(`/api/BizService/AddServeList`, folderInfo);
    },
    removeFolder({ ObjectID }) {
        return Http.GET(`/api/BizService/RemoveNode/${ObjectID}`);
    },
    updateFolder(folderInfo) {
        //{ ObjId: '', Name: '', Code: '' }
        return Http.POST(`/api/BizService/AddServeList`, folderInfo);
    },
    getFolderInFolder(Code = '') {
        return Http.POST(`/api/BizService/GetFunctioNode/${Code}`);
    },

    dropFolder(Code, ParentCode) {
        return Http.GET(`/api/BizService/MobileNode/${Code}/${ParentCode}`);
    },
    dropServe(ObjectID, ParentCode) {
        return Http.GET(`/api/BizService/MobileBizserves/${ObjectID}/${ParentCode}`);
    },
    getNodeList(Code = '') {
        return Http.GET(`api/DataSource/GetNodeConfigList/${Code}`);
    },
    getFormDataSource(code, obj) {
        return Http.POST(`api/DataSource/GetFormDataSource/${code}`, obj);
    },
    updateFormDataSource(code, obj) {
        return Http.POST(`api/DataSource/updateFormDataSource/${code}`, obj);
    },
    checkFieldLimit(schemaCode, fieldName, length, isAdd) {
        return Http.GET(`/api/DataSource/CheckFieldLimit/${schemaCode}/${fieldName}/${length}/${isAdd}`);
    }
};